module.exports = __webpack_public_path__ + "img/no-image.52fe4d6b.jpg";